import { FC } from 'react';
import { AddButton } from '../../../../../lib/components/Buttons/AddButton';
import { RemoveButton } from '../../../../../lib/components/Buttons/RemoveButton';
import { UpdateButton } from '../../../../../lib/components/Buttons/UpdateButton';
import { CellStyle } from '../../../../../lib/components/DataTable/CellStyle';
import { SearchableDataTable } from '../../../../../lib/components/SearchableDataTable/SearchableDataTable';
import { useRequestFeedback } from '../../../../../lib/hooks';
import { maskCpf } from '../../../../../lib/utils/cpfValidator';
import { SearchTagDto } from '../dto/SearchTagDto';
import { useSearchTagsApi } from '../hooks/SearchTagsApi';

interface IProps {
	on_remove_success: () => void;
	visible_insert_modal: () => void;
	title_of_the_item_to_be_removed: string;
	on_edit_click?: (tag: SearchTagDto) => void;
	show_cpf_column?: boolean;
}

export const SearchTagsDatatable: FC<IProps> = ({
	on_remove_success,
	visible_insert_modal,
	title_of_the_item_to_be_removed,
	on_edit_click,
	show_cpf_column,
}) => {
	const { remove } = useSearchTagsApi();

	if (remove.result) {
		on_remove_success();
	}

	useRequestFeedback(remove.result, remove.error);

	const columns: any[] = [
		{
			field: 'title',
			headerName: 'Titulo',
			resizable: true,
			width: 250,
		},
	];

	if (show_cpf_column) {
		columns.push({
			col_def: {
				field: 'cpf',
				headerName: 'CPF',
				resizable: true,
				width: 180,
			},
			renderer: (props: { data: SearchTagDto }) =>
				props.data.cpf ? maskCpf(props.data.cpf) : '—',
		});
	}

	const actionsWidth = on_edit_click ? 180 : 100;
	columns.push({
		col_def: {
			field: 'buttons',
			headerName: '',
			pinned: 'right',
			cellStyle: CellStyle.Centered,
			width: actionsWidth,
		},
		renderer: (props: { data: SearchTagDto }) => (
			<div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
				{on_edit_click && (
					<UpdateButton onClick={() => on_edit_click(props.data)} />
				)}
				<RemoveButton
					{...{
						on_confirm: () => remove.do_remove(props.data.id),
						title: `Deseja remover a ${title_of_the_item_to_be_removed} ${props.data.title}?`,
					}}
				/>
			</div>
		),
	});

	return (
		<SearchableDataTable
			{...{
				row_height: () => 50,
				sortable_fields: ['Titulo'],
				buttons_on_top: [<AddButton onClick={() => visible_insert_modal()} />],
				columns,
			}}
		/>
	);
};
